import React from 'react';
import { ExternalLink, ShieldCheck } from 'lucide-react';

const DoctIABanner = () => {
  return (
    <div className="w-full max-w-4xl mx-auto mt-16 mb-8 animate-in fade-in slide-in-from-bottom-4 duration-700">
      <a 
        href="https://doctia.com.ar" 
        target="_blank" 
        rel="noopener noreferrer"
        className="block group relative overflow-hidden rounded-3xl border border-blue-900/50 bg-gradient-to-br from-blue-950 via-slate-900 to-black p-1 transition-all hover:scale-[1.01] hover:shadow-[0_0_40px_rgba(59,130,246,0.2)] hover:border-blue-500/50"
      >
        {/* Background elements */}
        <div className="absolute inset-0 bg-[url('https://grainy-gradients.vercel.app/noise.svg')] opacity-20"></div>
        <div className="absolute -right-20 -top-20 w-64 h-64 bg-blue-600/10 rounded-full blur-[80px] group-hover:bg-blue-600/20 transition-colors"></div>
        
        <div className="relative flex flex-col md:flex-row items-center gap-6 p-6 md:p-8">
           {/* Visual/Image Section */}
           <div className="flex-shrink-0 relative">
              <div className="absolute inset-0 bg-blue-500 blur-2xl opacity-20 group-hover:opacity-40 transition-opacity"></div>
              <div className="relative w-20 h-20 md:w-24 md:h-24 bg-gradient-to-br from-blue-900 to-slate-900 rounded-2xl flex items-center justify-center border border-blue-700/50 shadow-xl group-hover:rotate-3 transition-transform duration-300">
                 {/* Placeholder for uploaded image - using Shield icon as fallback */}
                 <ShieldCheck className="w-10 h-10 md:w-12 md:h-12 text-blue-400" />
              </div>
           </div>

           {/* Text Section */}
           <div className="flex-1 text-center md:text-left space-y-3">
              <div className="flex items-center justify-center md:justify-start gap-3">
                <h3 className="text-xl md:text-2xl font-black text-white tracking-tight">DoctIA</h3>
                <span className="px-2 py-0.5 rounded text-[10px] font-bold uppercase tracking-widest bg-blue-500/20 text-blue-300 border border-blue-500/30">
                    Recomendado
                </span>
              </div>
              
              <p className="text-blue-100/90 text-base md:text-lg font-bold leading-snug">
                ¿Querés utilizar IA para encontrar jurisprudencia sin riesgo de resultados inexistentes?
              </p>
              
              <p className="text-slate-400 text-sm leading-relaxed max-w-2xl">
                Probá DoctIA, la IA desarrollada por abogados, para abogados, que te permite encontrar jurisprudencia 100% real, verificable y citable con un solo click.
              </p>
           </div>

           {/* CTA Button */}
           <div className="flex-shrink-0 mt-4 md:mt-0">
              <div className="px-6 py-3 bg-blue-600 hover:bg-blue-500 text-white font-bold rounded-xl shadow-lg shadow-blue-900/50 flex items-center gap-2 transition-all group-hover:translate-x-1 whitespace-nowrap">
                 Probar DoctIA <ExternalLink className="w-4 h-4" />
              </div>
           </div>
        </div>
      </a>
    </div>
  );
};

export default DoctIABanner;